/**
 * Very basic HTML5 video player functionality.
 */

import onscreen from 'onscreen';
import {breakpoints, isMobile, createCookie, readCookie} from '../helpers/born.utils';
import TrackingLayer from './module.tracking-layer';

/**
 * options::
 * 	autoplay: [Boolean] Allows video autoplay. Added as a property inside the data-video attribute because we don't want all videos to start playing even when out of screen view.
 *  clickToggle: [Boolean] Allow clicking on video to play/pause
 *  playOnSlideIn: [Boolean] Plays the video on Slick slide-in
 *  dynamicDetect: [Boolean] Wether to detect if video has audio in order to display specific styles/format
 *  youtubeID: [String] If video should load from a YouTube iframe, this is the YouTube video ID
 */

export default class Video{
	constructor(query) {
		this.query  	= query;
		this.videos 	= document.querySelectorAll(this.query + ':not([data-initialized])');
		this.ytVideos 	= [];

		[].forEach.call(this.videos, this.setupStream.bind(this));
		
		if( !this.setupYTStream() && window.innerWidth >= breakpoints.mobile ) {
			this.setOnScreen();
		}
	}

	setupStream(stream) {
		stream.video = {};
		stream.video.options = this.getSettings(stream);
		stream.setAttribute('data-initialized', true);

		//handling youtube videos and HTML5 videos
		if(stream.video.options.youtubeID) {
			this.ytVideos.push(stream);
		}

		//Tests if video should detect what kind of presentation to display
		else if(stream.video.options.dynamicDetect) {
			let videoInterval = window.setInterval(function(){
				let anyMobile = isMobile.any();

				//This is so terrible.
				if(anyMobile || this.hasAudio(stream)) {
					this.setVideoType(stream, anyMobile);
					this.setHandlers(stream);

					window.clearInterval(videoInterval);
				}
			}.bind(this), 100);
		}

		else {
			this.setHandlers(stream);
		}
	}

	//Loops through youtube videos and initializes them on API ready
	setupYTStream() {
		if(this.ytVideos.length) {
			if(window.ytIframeAPIReady) {
				this.renderYTVideos(this.ytVideos);
			}

			else {
				this.loadYTAPI();

				window.onYouTubeIframeAPIReady = function() {
					window.ytIframeAPIReady = true;
					this.renderYTVideos(this.ytVideos);
				}.bind(this);
			}

			return true;
		}

		return false;
	}

	/**
	 * Extracts video settings as a JSON object
	 * @return {JSON}        
	 */
	getSettings(stream) {
		var options = stream.getAttribute('data-video');

		return options ? JSON.parse(options) : {};
	}

	//Determines how the video should be displayed. Either as a cover video, or as a toggable video with audio.
	setVideoType(stream, forceToggle) {
		if(forceToggle || this.hasAudio(stream)) {
			stream.parentNode.classList.add('video--playwrap');
			stream.video.options.clickToggle = true;
			if (stream.video.options.handleloop && stream.video.options.autoplay) {
				let timeoutTmp = null;

				clearInterval(timeoutTmp);

				timeoutTmp = setInterval(function () {
					if ($(stream).is(':visible')) {
						if (stream.paused) {
							stream.play();
							clearInterval(timeoutTmp);
						}
					}
				}, 1000);
			}
		}

		else {
			stream.parentNode.classList.remove('video--playwrap');
			stream.parentNode.classList.add('video--cover');
			stream.loop = true;
			stream.muted = true;
			stream.video.options.autoplay = true;

			stream.play();
		}

		stream.classList.remove('hidden');
	}

	/**
	 * Sets up video's event handlers, not much more.
	 */
	setHandlers(stream) {
		let {clickToggle} = stream.video.options;
		let steamParent = stream.parentNode;
		let bindedClickHandler = this.toggleVideo.bind(stream);
		let hasPlaywrap = steamParent.classList.contains('video--playwrap');
		let videoBox = steamParent.closest('.video-box');
		let controlButtons = videoBox && videoBox.querySelectorAll('.js-video-control');

		if (clickToggle ) {
			//If video's parent has the video--playwrap class, add the handler to the parent instead so that we can toggle the pretty "play" icon on and off.
			//(hasPlaywrap ? steamParent : stream).addEventListener('click', hasPlaywrap ? bindedClickHandler : this.toggleVideo);

			if(hasPlaywrap) {
				let hasCoverwrap = steamParent.classList.contains('postdetail--video');
				if(hasCoverwrap) {
					steamParent.addEventListener('click', this.toggleCoverVideo.bind(stream));
					steamParent.querySelector('i').addEventListener('click', this.toggleVideoEvent.bind(stream));

					/*On Firefox*/
					stream.addEventListener('play', this.toggleCoverVideo.bind(stream));
					stream.addEventListener('pause', this.toggleCoverVideo.bind(stream));
				} else {
					if (!stream.classList.contains("video-redirect-element")) {
						steamParent.addEventListener("click", bindedClickHandler);
					}
				}
			} else {
				stream.addEventListener("click", this.toggleVideo);
			}
		}

		if (controlButtons && controlButtons.length) {
			controlButtons.forEach((button) => {
				button.addEventListener('click', bindedClickHandler);
			})
		}

		['playing', 'pause', 'ended'].forEach((event) => {
			let eventHandler = this[`${event}Handler`].bind(this);

			stream.addEventListener(event, (e) => {
				eventHandler(e, stream);
			});
		});
		this.autoplayFunction(stream);
		Video.initHandlers.call(this, stream);
	}

	/**
	 * Detects if video has audio
	 * @return {Boolean}
	 */
	hasAudio(stream) {
		return true;
	}

	autoplayFunction() {
		$(".video-redirect-element").each(function (index) {
			var videoElement = $(this); 
			var videoData = JSON.parse(videoElement.attr("data-video"));
			var buttons = $(".playPauseBtn"); 
		
			if (videoData.autoplay === true) {
				videoElement.prop("muted", true).get(0).play();
				videoElement.prop("loop", true);
			}
			
			$(buttons[index]).click(function () {
				var currentVideoElement = $(".video-redirect-element").eq(index)[0];
				if (currentVideoElement.paused) {
					if (videoData.muted === false) {
						$(currentVideoElement).prop('muted', true);
					}
					else{
						$(currentVideoElement).prop('muted', false);
					}
					setTimeout(() => {
						$(currentVideoElement).get(0).play();
					}, 50);
				} else {
					setTimeout(() => {
						$(currentVideoElement).get(0).pause();
					}, 50);
				}
			});
			videoElement.on("play", function () {
				$(buttons[index]).removeClass('icon--play');
				$(buttons[index]).addClass('icon--pause2');
			});

			videoElement.on("pause", function () {
				$(buttons[index]).removeClass('icon--pause2');
				$(buttons[index]).addClass('icon--play');
			});
			
			videoElement.on("ended", function () {
				$(buttons[index]).addClass('icon--play');
				$(buttons[index]).removeClass('icon--pause2');
			});
			videoElement.on('click', function(){
				var videoUrl = $(this).data("video-url");
				if(videoUrl){
					window.location.href = videoUrl;
				}
			});
		});
	}

	/**
	 * Initializes OnScreen, which toggles video playback automatically if said video has teh "autoplay" option or if video has the "playOnSlideIn" AND "videoSlideInView" is set to true (which means video is currently visible on the current slide). Note: "videoSlideInView" is set on the module.carousel module.
	 */
	setOnScreen() {
		this.OS = new onscreen({tolerance: 200});
		this.OS.on('enter', this.query, function(stream) {
			if( stream.video && (stream.video.options.autoplay || stream.video.videoSlideInView) ) {
				if (stream.video.paused) {
					stream.play();
				}
			}
		}.bind(this));
		this.OS.on('leave', this.query, function(stream) {
			if( stream.video && (stream.video.options.autoplay || stream.video.videoSlideInView) ) {
				stream.pause();
			}
		}.bind(this));
	}

	toggleVideo() {
		if( this.paused ) {
			this.play();
			$('.video-box__src,.video-box')
				.removeClass('h-mob-100');
		}
		else {
			this.pause();
		}
	}

	toggleCoverVideo() {
		$(this).on('play',()=>{
			$('.icon--play').hide();
			$('.video-box__src,.video-box')
				.removeClass('h-mob-100');
		})
		$(this).on('pause',()=>{
			$('.icon--play').show();
			
		})
	}

	toggleVideoEvent() {
		this.play();
		$(this).on('play',()=>{
			$('.icon--play').hide();	
			$('.video-box__src,.video-box')
				.removeClass('h-mob-100');
		})
		$(this).on('pause',()=>{
			$('.icon--play').show();
			
		})
	}

	/**
		* Updates currently playing video status classes in DOM.
	*/

	updateDOMComponents(stream, isStreamPaused) {
		let $carousel = $(stream).closest('.js-carousel-hero');
		let $videoBox = $(stream).closest('.video-box');

		[stream, stream.parentNode].forEach((node) => {
			node.classList[isStreamPaused ? 'remove' : 'add']('playing');
		});

		if ($carousel.length) {
			$carousel[`${isStreamPaused ? 'remove' : 'add'}Class`]('playing').slick(`slick${isStreamPaused ? 'Play' : 'Pause'}`);
		}

		if ($videoBox.length) {
			$videoBox[`${isStreamPaused ? 'remove' : 'add'}Class`]('playing');
		}
	}

	/**
		* Video play status handlers
	*/

	playingHandler(e, stream) {
		this.updateDOMComponents(stream, stream.paused);
	}

	pauseHandler(e, stream) {
		this.updateDOMComponents(stream, stream.paused);
	}

	endedHandler(e, stream) {
		this.updateDOMComponents(stream, true);

		if (stream.video.options.loop) {
			if (stream.video.options.handleloop) {
				let videoPlayCount = Video.getVideoCookieValue.call(stream);

				if (videoPlayCount > 0) {
					if (stream.paused) {
						stream.play();
					} else {
						$('.video-box__src,.video-box')
							.addClass('h-mob-100');
					}
					//TrackingLayer.pushData('autoplay_event: ' + window.Resources['NOSTOCK_SIGNUP']);
				} else if (videoPlayCount <= 0) {
					stream.video.options.autoplay = false;
					stream.currentTime = 0;
					stream.load();
					$('.video-box__src,.video-box')
						.addClass('h-mob-100');
				}
			} else {
				if (stream.paused) {
					stream.play();
				}
			}
		} else {
			$('.video-box__src,.video-box')
				.addClass('h-mob-100');
		}

		if (stream.video.options.backToStartOnVideoEnd) {
			stream.video.options.autoplay = false;
			stream.currentTime = 0;
			stream.load();
		}
	}

	static initHandlers(stream) {
		var _this = this;

		// Handle mute
		let $videoMuteBlock = $('.js-video-mute');
		if (stream.muted) {
			$videoMuteBlock.addClass('video-muted');
		}

		$videoMuteBlock.click(function(e) {
			e.preventDefault();
			stream.muted = !stream.muted;
			$(this).toggleClass('video-muted');

			let dataObj = {
				'name': 'N/A',
				'video_src': stream.currentSrc,
				'duration': stream.duration,
				'current_time': stream.currentTime,
				'event': stream.muted ? 'mute' : 'unmute'
			};

			TrackingLayer.pushData(dataObj, 'videoData');
			TrackingLayer.pushData('video');
			
		});

		// Handle loop playback
		if (stream.video.options.handleloop) {
			let videoPlayCount = Video.getVideoCookieValue.call(stream);

			if (videoPlayCount && videoPlayCount <= 0) {
				stream.video.options.autoplay = false;
				stream.pause();
			}
		}
	}

	static getVideoCookieValue() {
		const VIDEO_COOKIE_NAME = 'videoPlayCount',
			MAX_LOOP_TIMES = 2;
		let videoPlayCount = readCookie(VIDEO_COOKIE_NAME);

		if (videoPlayCount) {
			videoPlayCount = +videoPlayCount - 1;
		} else {
			videoPlayCount = MAX_LOOP_TIMES;
		}

		createCookie(VIDEO_COOKIE_NAME, videoPlayCount, SitePreferences.VIDEO_COOKIE_LIFETIME);

		return videoPlayCount;
	}

	//Youtube Integration
	renderYTVideos(ytVideos) {
		ytVideos.forEach(this.onYTAPIReady.bind(this));
	}

	/**
	 * Inserts youtube script into the DOM, which initializes video API access
	 * https://developers.google.com/youtube/iframe_api_reference
	 */
	loadYTAPI() {
		var ytTag = document.createElement('script'),
			firstTag = document.getElementsByTagName('script')[0];

		ytTag.src = "https://www.youtube.com/iframe_api";

		firstTag.parentNode.insertBefore(ytTag, firstTag);
	}

	/**
	 * Sets up configurations for the YouTube video object
	 * @param  {[Node]} stream [The youtube video element]
	 */
	onYTAPIReady(stream) {
		var videoTarget = document.createElement('div');

		stream.appendChild(videoTarget);

		stream.player = new window.YT.Player(videoTarget, {
			videoId: stream.video.options.youtubeID,
			playerVars: {
				// 'controls': 0,
				'showinfo': 1,
				'modestbranding': 1,
				'rel': 0,
				'origin': window.location.hostname
			},
			events: {
				'onStateChange': this.onYTStateChange.bind(stream)
			}
		});
	}

	onYTStateChange(evt) {
		if (evt.data === 3 || evt.data === 1) {
			this.classList.add('playing');
		}

		else {
			this.classList.remove('playing');
		}
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.video.js